"use strict";
exports.__esModule = true;
//# sourceMappingURL=message-campaign.type.js.map